module.exports = __webpack_public_path__ + "img/win_item2.62d4a732.png";